import {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {Stack, Typography} from '@mui/material';
import {useModalBtns} from '../../../../../../../../components/modal/use-modal-btns';
import {CompactModal} from '../../../../../../../../components/modal/compact-modal';
import {Attachment} from '../../../../../../../../backend/interfaces/attachment';
import {translations} from '../../../../../../../../i18n/translations';

export type SeniorAttachmentsDeleteModalProps = {
  open: boolean;
  attachment: Attachment;
  onClose: () => void;
  onDelete: () => Promise<void>;
};

export function SeniorAttachmentsDeleteModal(props: SeniorAttachmentsDeleteModalProps) {
  const {t} = useTranslation();
  const [deleting, setDeleting] = useState(false);

  const actionButtons = useModalBtns({
    left: {
      type: 'cancel',
      onClick: props.onClose,
    },
    right: {
      type: 'delete',
      onClick: async () => {
        try {
          setDeleting(true);
          await props.onDelete();
        } finally {
          setDeleting(false);
        }
      },
      disabled: deleting,
      loading: deleting,
    },
  });

  return (
    <CompactModal open={props.open} onClose={props.onClose} actions={actionButtons}>
      <Stack spacing={2} sx={{alignItems: 'center', paddingX: 2, paddingTop: '31px'}}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 500,
            textAlign: 'center',
          }}
        >
          <Trans
            i18nKey={translations.user_attachments.modals.delete.title}
            values={{name: props.attachment.name}}
          ></Trans>
        </Typography>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '500',
            textAlign: 'center',
            color: 'gray.input',
          }}
        >
          {t(translations.user_attachments.modals.delete.description)}
        </Typography>
      </Stack>
    </CompactModal>
  );
}
